<template>
    <div class="transaction">
        <div class="transaction_top">
            <div class="transaction_top_symbol transaction_top_symbol_hidden">
                <tran-symbol></tran-symbol>
            </div>
            <div class="transaction_top_kline transaction_top_kline_hidden transaction_top_kline_hidden_2">
                <div class="open_right" @click="openRight">
                    <img :src="right_src" alt="" />
                </div>
                <div class="open_left" @click="openLeft">
                    <img :src="left_src" alt="" />
                </div>
                <k-line></k-line>
            </div>
            <div class="transaction_top_right transaction_top_right_hidden">
                <offer-analysis-rule></offer-analysis-rule>
            </div>
        </div>
        <div class="transaction_bottom">
            <div class="transaction_bottom_assets transaction_bottom_assets_hidden">
                <assets></assets>
            </div>
            <div class="transaction_bottom_warehouse transaction_bottom_warehouse_hidden">
                <order-list></order-list>
            </div>
        </div>
    </div>
</template>

<script>
import tranSymbol from "./composition/TranSymbol";
import KLine from "./composition/KLine";
import offerAnalysisRule from "./composition/offerAnalysisRule";
import assets from "./composition/assets";
import orderList from "./composition/orderList";
import { useStore } from 'vuex';

import { useI18n } from "vue-i18n";
import { inject, ref } from "vue";


export default {
    name: "transactionPage",
    components: {
        tranSymbol,
        offerAnalysisRule,
        assets,
        orderList,
        KLine
    },
    setup() {
        const { t } = useI18n();
        const emitt = inject("emitt");
        const store = useStore();

        store.dispatch('getUserInfo');

        const right_src_open = t("trade.text152");
        const right_src_close = t("trade.text153");

        const left_src_open = t("trade.text154");
        const left_src_close = t("trade.text155");

        const right_src = ref(right_src_open);
        const left_src = ref(left_src_open);

        const open_right_text = t("trade.text151");
        const open_left_text = t("trade.text154");

        function openRight() {
            const right = document.getElementsByClassName("transaction_top_right")[0];
            const kline = document.getElementsByClassName("transaction_top_kline")[0];
            const left = document.getElementsByClassName("transaction_top_symbol")[0];

            if (right.classList.contains("transaction_top_right_hidden")) {
                right.classList.remove("transaction_top_right_hidden");
                right_src.value = right_src_close;
                emitt.$pub("activeSymbolChange");

                if (left.classList.contains("transaction_top_symbol_hidden")) {
                    kline.classList.add("transaction_top_kline_hidden");
                } else {
                    kline.classList.remove("transaction_top_kline_hidden");
                    kline.classList.remove("transaction_top_kline_hidden_2");
                }
            } else {
                right.classList.add("transaction_top_right_hidden");
                right_src.value = right_src_open;

                if (left.classList.contains("transaction_top_symbol_hidden")) {
                    kline.classList.add("transaction_top_kline_hidden_2");
                } else {
                    kline.classList.add("transaction_top_kline_hidden");
                }
            }
        }

        function openLeft() {
            const right = document.getElementsByClassName("transaction_top_right")[0];
            const kline = document.getElementsByClassName("transaction_top_kline")[0];
            const left = document.getElementsByClassName("transaction_top_symbol")[0];
            const warehouse = document.getElementsByClassName(
                "transaction_bottom_warehouse"
            )[0];
            const assets = document.getElementsByClassName(
                "transaction_bottom_assets"
            )[0];
            if (left.classList.contains("transaction_top_symbol_hidden")) {
                left.classList.remove("transaction_top_symbol_hidden");
                assets.classList.remove("transaction_bottom_assets_hidden");
                warehouse.classList.remove("transaction_bottom_warehouse_hidden");
                left_src.value = left_src_close;

                if (right.classList.contains("transaction_top_right_hidden")) {
                    kline.classList.add("transaction_top_kline_hidden");
                } else {
                    kline.classList.remove("transaction_top_kline_hidden");
                    kline.classList.remove("transaction_top_kline_hidden_2");
                }
            } else {
                left.classList.add("transaction_top_symbol_hidden");
                assets.classList.add("transaction_bottom_assets_hidden");
                warehouse.classList.add("transaction_bottom_warehouse_hidden");
                left_src.value = left_src_open;

                if (right.classList.contains("transaction_top_right_hidden")) {
                    kline.classList.add("transaction_top_kline_hidden_2");
                } else {
                    kline.classList.add("transaction_top_kline_hidden");
                }
            }
        }

        return {
            openRight,
            open_right_text,
            open_left_text,
            right_src,
            left_src,
            openLeft,
        };
    },
};
</script>
<style lang="less">
.transaction {
    height: 1160px;

    /*no*/
    .transaction_top {
        width: 100%;
        margin-top: 8px;
        display: flex;
        justify-content: space-between;

        .transaction_top_symbol {
            flex-shrink: 0;
            width: 310px;
            /*no*/
            height: 568px;
            /*no*/
            background: @white;
        }

        .transaction_top_kline {
            width: calc(100% - 630px);
            /*no*/
            margin: 0 10px;
            /*no*/
            height: 568px;
            /*no*/
            background: @white;
            position: relative;
            z-index: 9;

            .open_right {
                display: none;
                position: absolute;
                right: 0px;
                top: 120px;
                cursor: pointer;
            }

            .open_left {
                display: none;
                position: absolute;
                left: 0px;
                top: 120px;
                cursor: pointer;
            }
        }

        .transaction_top_right {
            flex-shrink: 0;

            width: 300px;
            /*no*/
            height: 568px;
            /*no*/
            background: @white;
            display: block;
        }
    }

    .transaction_bottom {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;

        .transaction_bottom_warehouse {
            width: calc(100% - 320px);
            /*no*/
            height: 576px;
            /*no*/
            background: @white;
        }

        .transaction_bottom_assets {
            flex-shrink: 0;

            width: 310px;
            /*no*/
            height: 576px;
            /*no*/
            background: @white;
        }
    }
}

@media (max-width: 1300px) {
    .transaction_top_right_hidden {
        display: none !important;
    }

    .transaction_top_kline_hidden {
        width: calc(100% - 320px) !important;
        /*no*/
    }

    .open_right {
        display: block !important;
    }
}

@media (max-width: 1100px) {
    .transaction_top_symbol_hidden {
        display: none !important;
    }

    .transaction_bottom_assets_hidden {
        display: none !important;
    }

    .transaction_bottom_warehouse_hidden {
        margin: 0 10px;
        /*no*/
        width: calc(100% - 20px) !important;
    }

    .transaction_top_kline_hidden_2 {
        width: 100% !important;
        /*no*/
    }

    .transaction_top_kline_hidden_3 {
        width: calc(100% - 320px) !important;
        /*no*/
    }

    .open_left {
        display: block !important;
    }
}
</style>